<template>
  <div class="min-h-screen bg-primary w-full h-full mt-[60px] lg:mt-0 themeTransition">
    <div v-if="!isLoading">
      <page-wrapper v-if="pageGUI" :page-gui="pageGUI">
        <!-- content begin -->
        <section
          class="sectionContainer py-5 md:pt-[140px] md:pb-32 mb-5 lg:min-h-full lg:mb-9"
        >
          <div class="col-span-12 col-start-2 md:col-span-5 md:col-start-2">
            <h2
              v-if="title"
              class="text-typography text-xs md:text-sm font-semibold mb-10 themeTransition"
            >
              {{ pageProperties?.tag }}
            </h2>
            <header1
              :text="title"
              classes="mb-5"
              :is-umbraco="isUmbraco"
              :theme="themeType"
            />
            <rich-text
              v-if="pageProperties?.description"
              :text="pageProperties.description.markup"
              classes="mb-8"
              :is-umbraco="isUmbraco"
              :theme="themeType"
            />
          </div>
          <div
            class="col-span-full col-start-1 md:col-span-5 md:col-start-8"
            v-if="pageProperties?.embedCode"
          >
            <div class="ml-embedded" :data-form="pageProperties?.embedCode"></div>
          </div>
        </section>
        <!-- content end -->
      </page-wrapper>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onBeforeMount, computed } from "vue";
import { parseUrl, changeTheme, getThemeType } from "@/util/helper";
import Header1 from "@components/Typography/Header1.ce.vue";

import RichText from "@components/Typography/RichText.ce.vue";
import PageWrapper from "@components/PageWrapper.vue";
import { Theme } from "@/types/types";
import { getPage, getPageByID } from "@/util/api";
import { INewsletterPage } from "@/types/INewsletterPage";

const isLoading = ref(true);
const environment = ref();
const urlParams = ref<String[] | null>(null);

const pageData = ref<INewsletterPage | null>(null);
const pageGUI = ref<string | undefined>();

const theme = ref<Theme | null>(null);

const iconArray = ref<Array<{ icon: string }>>([]);
const currentUrl = ref<string | null>(null);
const shareLabel = ref<string>("");

const isPreview = ref<boolean>(false);
const previewUrl = ref<string>("");
const isUmbraco = ref(false);
const pageKey = ref<string | undefined>();

onBeforeMount(async () => {
  pageKey.value = document.documentElement.dataset.id;
  const metaUrl = document.head.querySelector("meta[property='og:url']");
  if (metaUrl instanceof HTMLMetaElement) {
    previewUrl.value = metaUrl.content.replace(/^https?:\/\/[^/]+/, "");
  }

  environment.value = parseUrl(window.location.href).environment;
  urlParams.value = parseUrl(window.location.href).params;

  //create social share icons
  currentUrl.value = window.location.href;

  if (!urlParams.value) return;

  let path = urlParams.value.join("/");
  if (previewUrl.value.indexOf(path) < 0) {
    console.log("preview");
    path = previewUrl.value;
    isPreview.value = true;
  }
  if (path) {
    pageData.value = (await getPageByID(
      pageKey.value,
      isPreview.value
    )) as INewsletterPage;
    //pageData.value = (await getPage(path, isPreview.value)) as INewsletterPage;
    console.log("pageData.value: ", pageData.value);
    if (pageData.value) {
      theme.value = pageData.value.properties.backgroundColor;
      if (theme.value) changeTheme(theme.value);
      pageGUI.value = pageData.value.route.startItem.id;
      isLoading.value = false;
    }
  }
});

const pageProperties = computed(() => {
  return pageData.value?.properties;
});

const themeType = computed(() => {
  if (!theme.value) return "dark";
  return getThemeType(theme.value);
});

const title = computed(() => {
  return pageProperties.value?.title ?? "";
});
</script>
